import { render, staticRenderFns } from "./PopPickl.vue?vue&type=template&id=51b0bee8&scoped=true&"
import script from "./PopPickl.vue?vue&type=script&lang=js&"
export * from "./PopPickl.vue?vue&type=script&lang=js&"
import style0 from "./PopPickl.vue?vue&type=style&index=0&id=51b0bee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b0bee8",
  null
  
)

export default component.exports